function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M292,224.3c-6.6,0-12-5.4-12-12v-48c0-6.6,5.4-12,12-12h98.3C358.3,108.5,306.5,80,248,80 c-97.3,0-176,78.7-176,176c0,97.3,78.7,176,176,176c44.8,0,85.6-16.7,116.6-44.1c4.7-4.2,11.9-3.9,16.4,0.5l34,34 c4.9,4.9,4.6,12.8-0.5,17.4C370.5,479.7,312.1,504,248,504C111.2,504,0.3,393.3,0,256.5C-0.3,119.6,109.3,9,246.2,8 c73.9-0.5,140.4,31.3,186.2,82.1V12c0-6.6,5.4-12,12-12l48,0c6.6,0,12,5.4,12,12v200.3c0,6.6-5.4,12-12,12L292,224.3L292,224.3z"
});

function SvgIconRotateRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateRight);
export default __webpack_public_path__ + "static/media/icon_rotate_right.a5ef84db.svg";
export { ForwardRef as ReactComponent };